import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { ThemeManager } from './library/ThemeManager';

if (process.env.NODE_ENV === 'production') {
  const umami = document.createElement('script');
  umami.defer = true;
  umami.src = 'https://ua.jkrb.io/script.js';
  umami.dataset.websiteId = '316f7a1d-b177-442d-92ac-6f6a557b9a28';
  document.head.appendChild(umami);
}

ReactDOM.render(
  <ThemeManager>
    <App />
  </ThemeManager>
  , document.getElementById('root'));

serviceWorker.unregister();